import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

interface WidgetContainerTitleProps {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  className?: string;
}

export const WidgetContainerTitle: FC<WidgetContainerTitleProps> = ({
  icon,
  title,
  subtitle,
  className,
}) => (
  <div className={cx("flex shrink-0 items-center gap-2", className)}>
    {icon}
    <span className="text-dark-800 text-sm font-medium">{title}</span>
    {subtitle && (
      <span className="text-dark-600 text-xs font-normal">{subtitle}</span>
    )}
  </div>
);
